import { render, staticRenderFns } from "./accordion-tabs.vue?vue&type=template&id=985d12ca&"
import script from "./accordion-tabs.vue?vue&type=script&lang=js&"
export * from "./accordion-tabs.vue?vue&type=script&lang=js&"
import style0 from "./accordion-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports